import React from 'react';
import T from 'prop-types';

import AppInfo from '../../_shared/components/AppInfo';
import Container from '../../../../components/Container';

const Apps = ({ apps, header, subheader, isMobileView }) => (
  <div className="apps-wrapper">
    <Container maxWidth={1248}>
      <h1 className="apps-header">{header}</h1>
      <p className="apps-description">{subheader}</p>
    </Container>
    <Container className="apps-box" maxWidth={1248}>
      {apps.map((app, index) => (
        <a key={index} href={app.app_link_url} target="_blank" rel="noreferrer">
          <AppInfo
            app={app}
            size={isMobileView ? 48 : 56}
            direction="vertical"
            showTicker
            enableTooltip={!isMobileView}
          />
        </a>
      ))}
    </Container>
  </div>
);

Apps.propTypes = {
  apps: T.array.isRequired,
  header: T.string.isRequired,
  subheader: T.string.isRequired,
  isMobileView: T.bool.isRequired,
};

export default Apps;
